<template lang="pug">
.building
  .building__background
    span
    span
    span
    span
    span
    span
  .building__picture
    Pins
    <svg height="2095" class="js-picture" viewBox="0 0 737 2095" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.5">
    <path d="M257.771 712.441V682.087C257.771 588.648 307.006 512.9 367.742 512.9C428.477 512.9 477.713 588.648 477.713 682.087V712.441" stroke="url(#paint0_linear_2904:2938)" stroke-width="3"/>
    <path d="M270.709 702.987V676.191C270.709 593.703 314.152 526.834 367.742 526.834C421.332 526.834 464.776 593.703 464.776 676.191V702.987" stroke="url(#paint1_linear_2904:2938)" stroke-width="3"/>
    <path d="M432.927 543.751C432.927 437.121 403.742 350.68 367.74 350.68C331.739 350.68 302.554 439.111 302.554 545.742" stroke="url(#paint2_linear_2904:2938)" stroke-width="3"/>
    <path d="M424.966 537.781C424.966 441.044 399.346 362.623 367.741 362.623C336.137 362.623 310.517 441.044 310.517 537.781" stroke="url(#paint3_linear_2904:2938)" stroke-width="3"/>
    <path d="M403.071 381.034C403.071 287.595 387.254 204.384 367.741 204.384C348.229 204.384 332.411 288.59 332.411 382.029" stroke="url(#paint4_linear_2904:2938)" stroke-width="3"/>
    <path d="M352.799 220.5C352.799 104.925 359.703 2 368.219 2C376.735 2 383.639 106.156 383.639 221.731" stroke="url(#paint5_linear_2904:2938)" stroke-width="3"/>
    <path opacity="0.6" d="M286.135 692.536L292.604 628.842L315.494 680.593" stroke="url(#paint6_linear_2904:2938)" stroke-width="3"/>
    <path opacity="0.6" d="M338.881 674.623L365.752 573.608L397.598 674.623" stroke="url(#paint7_linear_2904:2938)" stroke-width="3"/>
    <path opacity="0.6" d="M421.98 681.091L437.406 632.823L448.354 693.034" stroke="url(#paint8_linear_2904:2938)" stroke-width="3"/>
    <path d="M352.812 512.9L365.75 422.336L382.669 512.9" stroke="url(#paint9_linear_2904:2938)" stroke-width="3"/>
    <path d="M406.056 523.848L410.534 486.527L418.496 531.312" stroke="url(#paint10_linear_2904:2938)" stroke-width="3"/>
    <path d="M314.996 533.8L319.475 494.489L332.91 521.36" stroke="url(#paint11_linear_2904:2938)" stroke-width="3"/>
    <path d="M358.783 352.173L364.754 284.499L376.199 352.173" stroke="url(#paint12_linear_2904:2938)" stroke-width="3"/>
    <rect x="200.553" y="1851.97" width="69.6506" height="36.8086" stroke="url(#paint13_linear_2904:2938)" stroke-width="3"/>
    <rect x="468.266" y="1851.97" width="69.6506" height="36.8086" stroke="url(#paint14_linear_2904:2938)" stroke-width="3"/>
    <rect x="200.553" y="1937.56" width="69.6506" height="36.8086" stroke="url(#paint15_linear_2904:2938)" stroke-width="3"/>
    <rect x="468.266" y="1937.56" width="69.6506" height="36.8086" stroke="url(#paint16_linear_2904:2938)" stroke-width="3"/>
    <rect x="326.945" y="1851.97" width="37.8038" height="36.8086" stroke="url(#paint17_linear_2904:2938)" stroke-width="3"/>
    <rect x="326.945" y="1937.56" width="37.8038" height="36.8086" stroke="url(#paint18_linear_2904:2938)" stroke-width="3"/>
    <rect x="326.945" y="2019.16" width="37.8038" height="36.8086" stroke="url(#paint19_linear_2904:2938)" stroke-width="3"/>
    <rect x="379.69" y="1851.97" width="37.8038" height="36.8086" stroke="url(#paint20_linear_2904:2938)" stroke-width="3"/>
    <rect x="379.69" y="1937.56" width="37.8038" height="36.8086" stroke="url(#paint21_linear_2904:2938)" stroke-width="3"/>
    <rect x="379.69" y="2019.16" width="37.8038" height="36.8086" stroke="url(#paint22_linear_2904:2938)" stroke-width="3"/>
    <ellipse cx="590.123" cy="1298.37" rx="12.4595" ry="11.2656" fill="#231F20"/>
    <path d="M365.252 1344.9C245.98 1344.9 149.291 1450.79 149.291 1581.42V2093.3H581.214V1581.42C581.214 1450.79 484.525 1344.9 365.252 1344.9Z" stroke="url(#paint23_linear_2904:2938)" stroke-width="3"/>
    <path d="M365.254 1393.67C261.371 1393.67 177.158 1485.76 177.158 1599.36V2044.53H553.349V1599.36C553.349 1485.76 469.136 1393.67 365.254 1393.67Z" stroke="url(#paint24_linear_2904:2938)" stroke-width="3"/>
    <path d="M369.233 1496.17C333.506 1496.17 304.544 1531.83 304.544 1627.54V2044.53H433.922V1627.54C433.922 1531.83 404.96 1496.17 369.233 1496.17Z" stroke="url(#paint25_linear_2904:2938)" stroke-width="3"/>
    <path d="M369.234 1481.24C326.362 1481.24 291.607 1520.01 291.607 1624.06V2077.38H446.861V1624.06C446.861 1520.01 412.106 1481.24 369.234 1481.24Z" stroke="url(#paint26_linear_2904:2938)" stroke-width="3"/>
    <path d="M365.253 1371.77C254.225 1371.77 164.22 1470.06 164.22 1591.31V2066.43H566.286V1591.31C566.286 1470.06 476.28 1371.77 365.253 1371.77Z" stroke="url(#paint27_linear_2904:2938)" stroke-width="3"/>
    <path d="M137.349 1318.53V1244.88C137.349 1114.34 243.172 1008.52 373.712 1008.52C504.252 1008.52 610.075 1114.34 610.075 1244.88V1319.52" stroke="url(#paint28_linear_2904:2938)" stroke-width="3"/>
    <path d="M153.273 1295.14V1240.77C153.273 1121.84 251.968 1025.44 373.713 1025.44C495.459 1025.44 594.153 1121.84 594.153 1240.77V1295.14" stroke="url(#paint29_linear_2904:2938)" stroke-width="3"/>
    <path d="M177.158 1113.51V1034.39C177.158 927.763 263.822 841.322 370.727 841.322C477.633 841.322 564.296 927.763 564.296 1034.39V1104.56" stroke="url(#paint30_linear_2904:2938)" stroke-width="3"/>
    <path d="M188.104 1099.08V1032.85C188.104 933.667 269.867 853.264 370.726 853.264C471.585 853.264 553.348 933.667 553.348 1032.85V1091.12" stroke="url(#paint31_linear_2904:2938)" stroke-width="3"/>
    <path d="M199.053 941.34V841.321C199.053 747.882 274.577 672.135 367.741 672.135C460.906 672.135 536.43 747.882 536.43 841.321V933.378" stroke="url(#paint32_linear_2904:2938)" stroke-width="3"/>
    <path d="M373.712 1186.66C220.637 1186.66 96.5449 1310.53 96.5449 1463.33V2092.8H650.879V1463.33C650.879 1310.53 526.787 1186.66 373.712 1186.66Z" stroke="url(#paint33_linear_2904:2938)" stroke-width="3"/>
    <path d="M373.712 1222.49C232.729 1222.49 118.439 1336.63 118.439 1477.43V2057.47H628.984V1477.43C628.984 1336.63 514.695 1222.49 373.712 1222.49Z" stroke="url(#paint34_linear_2904:2938)" stroke-width="3"/>
    <path opacity="0.6" d="M174.67 1468.8L141.828 1414.56L199.551 1429" stroke="url(#paint35_linear_2904:2938)" stroke-width="3"/>
    <path opacity="0.6" d="M223.932 1401.63L206.019 1306.58L271.703 1368.29" stroke="url(#paint36_linear_2904:2938)" stroke-width="3"/>
    <path opacity="0.6" d="M301.063 1356.34L305.044 1265.28L352.815 1345.4" stroke="url(#paint37_linear_2904:2938)" stroke-width="3"/>
    <path opacity="0.6" d="M381.177 1344.4L421.483 1266.77L428.947 1354.85" stroke="url(#paint38_linear_2904:2938)" stroke-width="3"/>
    <path opacity="0.6" d="M464.276 1370.28L523.492 1314.05L508.066 1403.12" stroke="url(#paint39_linear_2904:2938)" stroke-width="3"/>
    <path opacity="0.6" d="M532.448 1430.99L601.118 1404.11L558.324 1475.77" stroke="url(#paint40_linear_2904:2938)" stroke-width="3"/>
    <path opacity="0.6" d="M327.436 1189.65L365.751 1076.19L406.057 1187.16" stroke="url(#paint41_linear_2904:2938)" stroke-width="3"/>
    <path opacity="0.6" d="M327.436 1013.49L365.751 900.039L406.057 1011" stroke="url(#paint42_linear_2904:2938)" stroke-width="3"/>
    <path opacity="0.6" d="M236.87 1221.99L241.349 1118.49L292.104 1197.61" stroke="url(#paint43_linear_2904:2938)" stroke-width="3"/>
    <path opacity="0.6" d="M249.312 1043.35L253.292 938.852L304.048 1018.47" stroke="url(#paint44_linear_2904:2938)" stroke-width="3"/>
    <path opacity="0.6" d="M439.895 1194.12L486.67 1116.5L496.622 1215.02" stroke="url(#paint45_linear_2904:2938)" stroke-width="3"/>
    <path opacity="0.6" d="M431.436 1015.98L471.969 946.814L480.201 1034.39" stroke="url(#paint46_linear_2904:2938)" stroke-width="3"/>
    <path opacity="0.6" d="M537.427 1238.91L570.269 1210.55V1267.77" stroke="url(#paint47_linear_2904:2938)" stroke-width="3"/>
    <path opacity="0.6" d="M170.689 1273.74L164.22 1214.53L201.54 1246.37" stroke="url(#paint48_linear_2904:2938)" stroke-width="3"/>
    <path opacity="0.6" d="M192.583 1091.62L194.573 1029.92L218.956 1065.74" stroke="url(#paint49_linear_2904:2938)" stroke-width="3"/>
    <path opacity="0.6" d="M519.013 1057.78L541.903 1019.46V1078.18" stroke="url(#paint50_linear_2904:2938)" stroke-width="3"/>
    <path opacity="0.6" d="M269.713 869.685L278.172 764.192L316.488 848.287" stroke="url(#paint51_linear_2904:2938)" stroke-width="3"/>
    <path opacity="0.6" d="M338.381 844.307L364.754 738.317L396.103 842.317" stroke="url(#paint52_linear_2904:2938)" stroke-width="3"/>
    <path opacity="0.6" d="M421.98 848.287L451.339 767.675L464.775 865.206" stroke="url(#paint53_linear_2904:2938)" stroke-width="3"/>
    <path opacity="0.6" d="M487.168 880.135L500.106 837.34L510.058 900.039" stroke="url(#paint54_linear_2904:2938)" stroke-width="3"/>
    <path opacity="0.6" d="M222.938 909.494L227.416 833.36L248.813 884.116" stroke="url(#paint55_linear_2904:2938)" stroke-width="3"/>
    <rect x="306.044" y="1432.98" width="25.8612" height="36.8086" stroke="url(#paint56_linear_2904:2938)" stroke-width="3"/>
    <rect x="238.37" y="1515.58" width="25.8612" height="36.8086" stroke="url(#paint57_linear_2904:2938)" stroke-width="3"/>
    <rect x="200.553" y="1601.17" width="69.6506" height="36.8086" stroke="url(#paint58_linear_2904:2938)" stroke-width="3"/>
    <rect x="468.266" y="1601.17" width="69.6506" height="36.8086" stroke="url(#paint59_linear_2904:2938)" stroke-width="3"/>
    <rect x="200.553" y="1686.76" width="69.6506" height="36.8086" stroke="url(#paint60_linear_2904:2938)" stroke-width="3"/>
    <rect x="468.266" y="1686.76" width="69.6506" height="36.8086" stroke="url(#paint61_linear_2904:2938)" stroke-width="3"/>
    <rect x="200.553" y="1772.35" width="69.6506" height="36.8086" stroke="url(#paint62_linear_2904:2938)" stroke-width="3"/>
    <rect x="468.266" y="1772.35" width="69.6506" height="36.8086" stroke="url(#paint63_linear_2904:2938)" stroke-width="3"/>
    <rect x="465.279" y="1515.58" width="25.8612" height="36.8086" stroke="url(#paint64_linear_2904:2938)" stroke-width="3"/>
    <rect x="326.945" y="1601.17" width="37.8038" height="36.8086" stroke="url(#paint65_linear_2904:2938)" stroke-width="3"/>
    <rect x="326.945" y="1686.76" width="37.8038" height="36.8086" stroke="url(#paint66_linear_2904:2938)" stroke-width="3"/>
    <rect x="326.945" y="1772.35" width="37.8038" height="36.8086" stroke="url(#paint67_linear_2904:2938)" stroke-width="3"/>
    <rect x="379.69" y="1601.17" width="37.8038" height="36.8086" stroke="url(#paint68_linear_2904:2938)" stroke-width="3"/>
    <rect x="379.69" y="1686.76" width="37.8038" height="36.8086" stroke="url(#paint69_linear_2904:2938)" stroke-width="3"/>
    <rect x="379.69" y="1772.35" width="37.8038" height="36.8086" stroke="url(#paint70_linear_2904:2938)" stroke-width="3"/>
    <rect x="406.562" y="1432.98" width="25.8612" height="36.8086" stroke="url(#paint71_linear_2904:2938)" stroke-width="3"/>
    <path d="M198.057 912.977V912.977C167.252 926.265 147.301 956.6 147.301 990.149V1178.2" stroke="url(#paint72_linear_2904:2938)" stroke-width="3"/>
    <path d="M149.292 1089.13V1089.13C124.579 1104.1 109.483 1130.9 109.483 1159.8V1378.24" stroke="url(#paint73_linear_2904:2938)" stroke-width="3"/>
    <path d="M109.482 1283.2V1283.2C87.2786 1296.31 73.6543 1320.17 73.6543 1345.95V1453.38" stroke="url(#paint74_linear_2904:2938)" stroke-width="3"/>
    <path d="M73.6554 1453.38V1453.38C33.2278 1456.47 2 1490.17 2 1530.71V2093.3" stroke="url(#paint75_linear_2904:2938)" stroke-width="3"/>
    <path d="M536.918 907.005V907.005C573.607 923.996 597.088 960.748 597.088 1001.18V1166.26" stroke="url(#paint76_linear_2904:2938)" stroke-width="3"/>
    <path d="M597.137 1090.12V1090.12C619.482 1104.54 632.981 1129.32 632.981 1155.91V1363.81" stroke="url(#paint77_linear_2904:2938)" stroke-width="3"/>
    <path d="M632.981 1283.2V1283.2C654.129 1296.35 666.987 1319.49 666.987 1344.4V1453.38" stroke="url(#paint78_linear_2904:2938)" stroke-width="3"/>
    <path d="M666.987 1453.38V1453.38C705.401 1456.47 734.999 1488.54 734.999 1527.08V2093.3" stroke="url(#paint79_linear_2904:2938)" stroke-width="3"/>
    </g>
    <defs>
    <linearGradient id="paint0_linear_2904:2938" x1="257.771" y1="612.671" x2="477.713" y2="612.671" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint1_linear_2904:2938" x1="270.709" y1="614.91" x2="464.776" y2="614.91" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint2_linear_2904:2938" x1="302.554" y1="448.211" x2="432.927" y2="448.211" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint3_linear_2904:2938" x1="310.517" y1="450.202" x2="424.966" y2="450.202" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint4_linear_2904:2938" x1="332.411" y1="293.207" x2="403.071" y2="293.207" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint5_linear_2904:2938" x1="383.639" y1="111.866" x2="352.799" y2="111.866" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint6_linear_2904:2938" x1="286.135" y1="660.689" x2="315.494" y2="660.689" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint7_linear_2904:2938" x1="338.881" y1="624.116" x2="397.598" y2="624.116" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint8_linear_2904:2938" x1="421.98" y1="662.928" x2="448.354" y2="662.928" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint9_linear_2904:2938" x1="352.812" y1="467.618" x2="382.669" y2="467.618" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint10_linear_2904:2938" x1="406.056" y1="508.92" x2="418.496" y2="508.92" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint11_linear_2904:2938" x1="314.996" y1="514.144" x2="332.91" y2="514.144" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint12_linear_2904:2938" x1="358.783" y1="318.336" x2="376.199" y2="318.336" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint13_linear_2904:2938" x1="199.053" y1="1870.37" x2="271.703" y2="1870.37" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint14_linear_2904:2938" x1="466.766" y1="1870.37" x2="539.416" y2="1870.37" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint15_linear_2904:2938" x1="199.053" y1="1955.96" x2="271.703" y2="1955.96" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint16_linear_2904:2938" x1="466.766" y1="1955.96" x2="539.416" y2="1955.96" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint17_linear_2904:2938" x1="325.445" y1="1870.37" x2="366.249" y2="1870.37" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint18_linear_2904:2938" x1="325.445" y1="1955.96" x2="366.249" y2="1955.96" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint19_linear_2904:2938" x1="325.445" y1="2037.57" x2="366.249" y2="2037.57" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint20_linear_2904:2938" x1="378.19" y1="1870.37" x2="418.994" y2="1870.37" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint21_linear_2904:2938" x1="378.19" y1="1955.96" x2="418.994" y2="1955.96" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint22_linear_2904:2938" x1="378.19" y1="2037.57" x2="418.994" y2="2037.57" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint23_linear_2904:2938" x1="149.291" y1="1719.1" x2="581.214" y2="1719.1" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint24_linear_2904:2938" x1="177.158" y1="1719.1" x2="553.349" y2="1719.1" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint25_linear_2904:2938" x1="304.544" y1="1770.35" x2="433.922" y2="1770.35" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint26_linear_2904:2938" x1="291.607" y1="1779.31" x2="446.861" y2="1779.31" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint27_linear_2904:2938" x1="164.22" y1="1719.1" x2="566.286" y2="1719.1" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint28_linear_2904:2938" x1="137.349" y1="1164.02" x2="610.075" y2="1164.02" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint29_linear_2904:2938" x1="153.273" y1="1160.29" x2="594.153" y2="1160.29" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint30_linear_2904:2938" x1="177.158" y1="977.417" x2="564.296" y2="977.417" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint31_linear_2904:2938" x1="188.104" y1="976.173" x2="553.348" y2="976.173" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint32_linear_2904:2938" x1="199.053" y1="806.737" x2="536.43" y2="806.737" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint33_linear_2904:2938" x1="96.5449" y1="1639.73" x2="650.879" y2="1639.73" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint34_linear_2904:2938" x1="118.439" y1="1639.98" x2="628.984" y2="1639.98" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint35_linear_2904:2938" x1="141.828" y1="1441.68" x2="199.551" y2="1441.68" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint36_linear_2904:2938" x1="206.019" y1="1354.11" x2="271.703" y2="1354.11" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint37_linear_2904:2938" x1="301.063" y1="1310.81" x2="352.815" y2="1310.81" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint38_linear_2904:2938" x1="381.177" y1="1310.81" x2="428.947" y2="1310.81" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint39_linear_2904:2938" x1="464.276" y1="1358.58" x2="523.492" y2="1358.58" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint40_linear_2904:2938" x1="532.448" y1="1439.94" x2="601.118" y2="1439.94" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint41_linear_2904:2938" x1="327.436" y1="1132.92" x2="406.057" y2="1132.92" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint42_linear_2904:2938" x1="327.436" y1="956.766" x2="406.057" y2="956.766" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint43_linear_2904:2938" x1="236.87" y1="1170.24" x2="292.104" y2="1170.24" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint44_linear_2904:2938" x1="249.312" y1="991.1" x2="304.048" y2="991.1" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint45_linear_2904:2938" x1="439.895" y1="1165.76" x2="496.622" y2="1165.76" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint46_linear_2904:2938" x1="431.436" y1="990.603" x2="480.201" y2="990.603" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint47_linear_2904:2938" x1="537.427" y1="1239.16" x2="570.269" y2="1239.16" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint48_linear_2904:2938" x1="164.22" y1="1244.13" x2="201.54" y2="1244.13" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint49_linear_2904:2938" x1="192.583" y1="1060.77" x2="218.956" y2="1060.77" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint50_linear_2904:2938" x1="519.013" y1="1048.82" x2="541.903" y2="1048.82" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint51_linear_2904:2938" x1="269.713" y1="816.938" x2="316.488" y2="816.938" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint52_linear_2904:2938" x1="338.381" y1="791.312" x2="396.103" y2="791.312" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint53_linear_2904:2938" x1="421.98" y1="816.44" x2="464.775" y2="816.44" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint54_linear_2904:2938" x1="487.168" y1="868.69" x2="510.058" y2="868.69" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint55_linear_2904:2938" x1="222.938" y1="871.427" x2="248.813" y2="871.427" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint56_linear_2904:2938" x1="304.544" y1="1451.39" x2="333.405" y2="1451.39" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint57_linear_2904:2938" x1="236.87" y1="1533.99" x2="265.731" y2="1533.99" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint58_linear_2904:2938" x1="199.053" y1="1619.58" x2="271.703" y2="1619.58" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint59_linear_2904:2938" x1="466.766" y1="1619.58" x2="539.416" y2="1619.58" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint60_linear_2904:2938" x1="199.053" y1="1705.17" x2="271.703" y2="1705.17" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint61_linear_2904:2938" x1="466.766" y1="1705.17" x2="539.416" y2="1705.17" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint62_linear_2904:2938" x1="199.053" y1="1790.76" x2="271.703" y2="1790.76" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint63_linear_2904:2938" x1="466.766" y1="1790.76" x2="539.416" y2="1790.76" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint64_linear_2904:2938" x1="463.779" y1="1533.99" x2="492.64" y2="1533.99" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint65_linear_2904:2938" x1="325.445" y1="1619.58" x2="366.249" y2="1619.58" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint66_linear_2904:2938" x1="325.445" y1="1705.17" x2="366.249" y2="1705.17" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint67_linear_2904:2938" x1="325.445" y1="1790.76" x2="366.249" y2="1790.76" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint68_linear_2904:2938" x1="378.19" y1="1619.58" x2="418.994" y2="1619.58" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint69_linear_2904:2938" x1="378.19" y1="1705.17" x2="418.994" y2="1705.17" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint70_linear_2904:2938" x1="378.19" y1="1790.76" x2="418.994" y2="1790.76" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint71_linear_2904:2938" x1="405.062" y1="1451.39" x2="433.923" y2="1451.39" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint72_linear_2904:2938" x1="147.301" y1="1045.59" x2="198.057" y2="1045.59" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint73_linear_2904:2938" x1="109.483" y1="1233.68" x2="149.292" y2="1233.68" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint74_linear_2904:2938" x1="73.6543" y1="1368.29" x2="109.482" y2="1368.29" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint75_linear_2904:2938" x1="2" y1="1773.34" x2="73.6554" y2="1773.34" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint76_linear_2904:2938" x1="597.088" y1="1036.63" x2="536.918" y2="1036.63" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint77_linear_2904:2938" x1="632.981" y1="1226.97" x2="597.137" y2="1226.97" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint78_linear_2904:2938" x1="666.987" y1="1368.29" x2="632.981" y2="1368.29" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    <linearGradient id="paint79_linear_2904:2938" x1="734.999" y1="1773.34" x2="666.987" y2="1773.34" gradientUnits="userSpaceOnUse">
    <stop stop-color="#BE965D"/>
    <stop offset="0.2784" stop-color="#976F40"/>
    <stop offset="0.4259" stop-color="#C99B61"/>
    <stop offset="0.5584" stop-color="#F0BE7B"/>
    <stop offset="0.6275" stop-color="#FFCB85"/>
    <stop offset="0.7085" stop-color="#EEBC79"/>
    <stop offset="0.8693" stop-color="#C0935B"/>
    <stop offset="1" stop-color="#976F40"/>
    </linearGradient>
    </defs>
    </svg>
</template>

<script>
import Vivus from "vivus";
import Pins from "../Pins/index";

export default {
  name: "Building",
  components: {
    Pins
  },
  mounted() {
    const vivus = new Vivus(this.$el.querySelector(".js-picture"), {
      type: "delayed",
      duration: 100,
      start: "manual",
    });

    const options = {
      threshold: [0, 1],
    };

    const callback = (entries, observer) => {
      if (entries[0].isIntersecting) {
        entries[0].target.classList.add("is-active");
        vivus.play();
      }
    };

    const observer = new IntersectionObserver(callback, options);
    observer.observe(this.$el);
  },
};
</script>

<style lang="sass" scoped>
@import "src/sass/general/medias"

.building
  height: 100%
  position: relative
  width: 64vw
  margin: 0 7vw
  &.is-active
    .building__background
      transform: scale(1)
      opacity: 1
      span
        opacity: 1
        &:nth-child(1)
          transform: scaleY(1) rotate(20deg)
          transition-delay: .2s
        &:nth-child(2)
          transform: scaleY(1) rotate(30deg)
          transition-delay: .4s
        &:nth-child(3)
          transform: scaleY(1) rotate(40deg)
          transition-delay: .6s
        &:nth-child(4)
          transform: scaleY(1) rotate(-20deg)
          transition-delay: .2s
        &:nth-child(5)
          transform: scaleY(1) rotate(-30deg)
          transition-delay: .4s
        &:nth-child(6)
          transform: scaleY(1) rotate(-40deg)
          transition-delay: .6s
    .building__picture
      opacity: 1
      transform: translateY(0vh)

.building__background
  background-color: #0b0a0a38
  border-radius: 100%
  width: 75em
  height: 75em
  position: absolute
  z-index: -1
  top: 0px
  left: 0px
  right: 0px
  bottom: 0px
  margin: auto
  opacity: 0
  transition-duration: 1.2s
  transition-timing-function: ease
  transform: scale(.5)
  transition-delay: .3s
  overflow: hidden
  @media (max-width: $l-desktop)
    width: 45em
    height: 45em
  @media (max-width: $b-tablet)
    display: none
  span
    height: 110vh
    position: absolute
    width: 10%
    margin: auto
    bottom: -30vh
    left: 0px
    transition-timing-function: ease
    right: 0
    transition-duration: 2s
    border: 100px solid transparent
    border-top: 120em solid rgba(255,255,255,0.008)
    opacity: 0
    transform-origin: bottom
    &:nth-child(1)
      left: -70%
      transform: scaleY(0) rotate(-50deg)
    &:nth-child(2)
      left: -70%
      transform: scaleY(0) rotate(-45deg)
    &:nth-child(3)
      left: -70%
      transform: scaleY(0) rotate(-35deg)
    &:nth-child(4)
      right: -70%
      transform: scaleY(0) rotate(50deg)
    &:nth-child(5)
      right: -70%
      transform: scaleY(0) rotate(45deg)
    &:nth-child(6)
      right: -70%
      transform: scaleY(0) rotate(35deg)

.building__picture
  height: 100%
  oferflow: hidden
  position: absolute
  top: 0
  display: flex
  left: 0
  width: 100%
  transition-duration: 1.2s
  opacity: 0
  transition-timing-function: ease
  transform: translateY(25vh)
  transition-delay: .5s
  svg
    height: 100%
    margin: 0 auto
</style>
